import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';

import { AbstractLayer, AbstractLayerProps, LayerProps } from './AbstractLayer';

export interface Props extends AbstractLayerProps {
    url: string;
}

/**
 * AbstractLayer implementation for XYZ/slippy-map tile endpoints
 * (URL templates of the form `.../{z}/{x}/{y}.png`).
 *
 * Used for WMTS endpoints exposed as XYZ (e.g. MapProxy) where the
 * full WMTSCapabilities negotiation isn't required.
 */
export class XYZLayer extends AbstractLayer<TileLayer<XYZ>> {
    private source: XYZ;

    constructor({ url, ...props }: Props) {
        super(props);
        this.source = new XYZ({
            url,
            crossOrigin: 'anonymous',
        });
    }

    initializeLayer(props: LayerProps): TileLayer<XYZ> {
        return new TileLayer({
            ...props,
            source: this.source,
        });
    }

    applyAuthentication() {}
}

export default XYZLayer;
